import gql from 'graphql-tag';

export const dokkioTagSummaryFragment = gql`
  fragment dokkioTagSummaryFragment on DokkioTagSummary {
    id
    effectiveWhatsNewSentence
    effectiveWhatsNewParagraph
    extendedSummary
  }
`;
export default dokkioTagSummaryFragment;
